<div
  *ngIf="paymentInfo"
  class="payment-detail">
  <div class="payment-detail__head">
    <h2 class="headline">{{ "PAYMENT_PAGE.MODAL_INFO.TITLE" | translate }}</h2>
    <button
      [cdkCopyToClipboard]="text"
      (cdkCopyToClipboardCopied)="onClipboardCopy($event)"
      class="payment-detail__head-copy-btn">
      <img
        src="assets/img/copy.svg"
        alt="Copy"
        class="icon" />
    </button>
  </div>

  <div
    *ngIf="paymentInfo.count_files > 0"
    class="payment-detail__download">
    <img
      src="assets/img/attach.svg"
      alt="Attach"
      class="payment-detail__download-icon" />
    <p class="payment-detail__download-title">
      {{ "PAYMENT_PAGE.FILES_TO_DOWNLOAD" | translate }}:
      <span>{{ paymentInfo.count_files }}</span>
      {{ "PAYMENT_PAGE.COUNT" | translate }}
    </p>
    <button
      (click)="downloadFiles(paymentInfo.id)"
      class="payment-detail__download-link">
      {{ "PAYMENT_PAGE.DOWNLOAD" | translate }}
    </button>
  </div>

  <div
    #modalBlock
    [class.active]="true"
    class="scroll-block">
    <div class="payment-detail__line">
      <div class="payment-detail__line-left">
        <div class="info-block">
          <h3 class="info-block__headline">
            {{ "PAYMENT_PAGE.MODAL_INFO.PAYMENT" | translate }}
          </h3>

          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.ID" | translate }}
            </div>
            <div class="info-block__line-right">{{ paymentInfo.id }}</div>
          </div>

          <div
            *ngIf="paymentInfo.payment_status === 'SUCCESSFUL_REFUND' || paymentInfo.payment_status === 'REFUND_INITIATED'"
            class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.RETURN_ID" | translate }}
            </div>
            <div class="info-block__line-right">{{ paymentInfo.payment_id }}</div>
          </div>

          <div
            *ngIf="!!paymentInfo.paylink_id"
            class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.PAYMENT_LINK_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.paylink_id }}
            </div>
          </div>
          <div
            *ngIf="!!paymentInfo.rec_payment_id"
            class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.RECURRENT_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.rec_payment_id }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.BANK_PAYMENT_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.bank_payment_id }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.INVOICE_ID" | translate }}
            </div>
            <div class="info-block__line-right">{{ paymentInfo.bill_id }}</div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.BILL_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.invoice_id }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.PAYMENT_STATUS" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ "PAYMENT_PAGE.PAYMENT_STATUS_DESCRIPTION." + paymentInfo.payment_status | translate }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.BANK_NAME" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.bank_name }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.TERMINAL_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.terminal_id }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.VIRTUAL_POS_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.virtual_pos_id }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.PAYMENT_TYPE" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ "PAYMENT_PAGE.PAYMENT_TYPE_DESCRIPTION." + paymentInfo.payment_type | translate }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.DATE" | translate }}
            </div>
            <div class="info-block__line-right">{{ paymentInfo.date }}</div>
          </div>
          <div
            *ngIf="!!paymentInfo.payer_card"
            class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.PAYER_CARD" | translate }}
            </div>
            <div class="info-block__line-right">**** **** **** {{ paymentInfo.payer_card }}</div>
          </div>
          <div
            *ngIf="!!paymentInfo.payee_card"
            class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.PAYEE_CARD" | translate }}
            </div>
            <div class="info-block__line-right">**** **** **** {{ paymentInfo.payee_card }}</div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.PAYMENT_DIRECTION" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.payment_direction }}
            </div>
          </div>
        </div>
      </div>
      <div class="payment-detail__line-right">
        <div
          *ngIf="
            paymentInfo?.payment_type !== 'RETURNS' && paymentInfo?.payment_type !== 'P2P_REFUNDS' && paymentInfo?.payment_type !== 'CASH_REFUNDS'
          "
          class="info-block">
          <div
            [class.active]="isOpenAccordionOne"
            (click)="openAccordionOne()"
            [class.accordion]="paymentInfo.claims.length"
            [class.mb0]="!paymentInfo.claims.length"
            class="info-block__headline">
            <div class="info-block__headline-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.SUM_PAYMENT" | translate }}
            </div>
            <div class="info-block__headline-right">
              {{paymentInfo.amount}}
              <span class="currency"> {{ paymentInfo.currency }}</span>
            </div>
          </div>
          <div
            [class.invisible]="!isOpenAccordionOne"
            class="accordion-body">
            <div
              *ngFor="let item of paymentInfo.claims"
              class="info-block__line">
              <div class="info-block__line-left">
                {{ item.infoline }}
              </div>
              <div class="info-block__line-right">
                <strong>{{ item.sum_with_commissions }}</strong>
                <span class="currency"> {{ paymentInfo.currency }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            paymentInfo?.payment_type !== 'RETURNS' && paymentInfo?.payment_type !== 'P2P_REFUNDS' && paymentInfo?.payment_type !== 'CASH_REFUNDS'
          "
          class="info-block">
          <div
            [class.active]="isOpenAccordionTwo"
            (click)="isOpenAccordionTwo = !isOpenAccordionTwo"
            class="info-block__headline accordion">
            <div class="info-block__headline-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.SUM_COMMISSION" | translate }}
            </div>
            <div class="info-block__headline-right">
              {{ paymentInfo.commission_sum }}
              <span class="currency"> {{ paymentInfo.currency }}</span>
            </div>
          </div>
          <div
            [class.invisible]="!isOpenAccordionTwo"
            class="accordion-body">
            <div class="info-block__line">
              <div class="info-block__line-left">
                {{ "PAYMENT_PAGE.MODAL_INFO.COMMISSION_PAYER_SUM" | translate }}
              </div>
              <div class="info-block__line-right">
                {{ paymentInfo.commission_payer_sum }}
                <span class="currency"> {{ paymentInfo.currency }}</span>
              </div>
            </div>
            <div class="info-block__line">
              <div class="info-block__line-left">
                {{ "PAYMENT_PAGE.MODAL_INFO.COMMISSION_AGENT_SUM" | translate }}
              </div>
              <div class="info-block__line-right">
                {{ paymentInfo.commission_agent_sum }}
                <span class="currency"> {{ paymentInfo.currency }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            paymentInfo?.payment_type !== 'RETURNS' && paymentInfo?.payment_type !== 'P2P_REFUNDS' && paymentInfo?.payment_type !== 'CASH_REFUNDS'
          "
          class="info-block">
          <div
            [class.mb0]="!paymentInfo.refund_amount"
            class="info-block__headline">
            <div class="info-block__headline-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.REFUND_AVAILABLE_AMOUNT" | translate }}
            </div>
            <div class="info-block__headline-right">
              {{ paymentInfo.refund_available_sum || 0 }}
              <span class="currency"> {{ paymentInfo.currency }}</span>
            </div>
          </div>

          <div
            *ngIf="!!paymentInfo.refund_amount"
            class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.REFUND_AMOUNT" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.refund_amount }}
              <span class="currency"> {{ paymentInfo.currency }}</span>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            paymentInfo?.payment_type === 'RETURNS' || paymentInfo?.payment_type === 'P2P_REFUNDS' || paymentInfo?.payment_type === 'CASH_REFUNDS'
          "
          class="info-block">
          <div class="info-block__headline mb0">
            <div class="info-block__headline-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.REFUND_AMOUNT" | translate }}
            </div>
            <div class="info-block__headline-right">
              {{ paymentInfo.refund_amount }}
              <span class="currency"> {{ paymentInfo.currency }}</span>
            </div>
          </div>
        </div>

        <div class="info-block">
          <h3 class="info-block__headline">
            {{ "PAYMENT_PAGE.MODAL_INFO.PAYER" | translate }}
          </h3>
          <div *ngIf="paymentInfo.payer_id" class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.AGENT_CLIENT_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.payer_id }}
            </div>
          </div>
          <div *ngIf="paymentInfo.full_name" class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.FULL_NAME" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.full_name }}
            </div>
          </div>
          <div *ngIf="paymentInfo.address" class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.ADDRESS" | translate }}
            </div>
            <div class="info-block__line-right">{{ paymentInfo.address }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="payment-detail__line">
      <div class="payment-detail__line-left">
        <div class="info-block">
          <h3 class="info-block__headline">
            {{ "PAYMENT_PAGE.MODAL_INFO.INFOLINE" | translate }}
          </h3>
          <p class="info-block__description">{{ paymentInfo.infoline }}</p>
        </div>
      </div>

      <div
        *ngIf="!paymentStatus && paymentInfo.bank_payment_info && paymentInfo.is_bank_match !== null"
        class="payment-detail__line-right">
        <div
          *ngIf="!paymentInfo.is_bank_match"
          class="info-block danger">
          <h3 class="info-block__headline">
            {{ "PAYMENT_PAGE.MODAL_INFO.STATUS" | translate }}
          </h3>
          <p class="info-block__description">
            {{ "PAYMENT_PAGE.MODAL_INFO.STATUS_ERROR" | translate }}
          </p>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.BANK_PAYMENT_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.bank_payment_info.bank_payment_id }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.PAYMENT_SUM" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.bank_payment_info.payment_sum }}
              <span class="currency">{{ paymentInfo.bank_payment_info.currency }}</span>
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.STATUS" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentInfo.bank_payment_info.payment_status }}
            </div>
          </div>
        </div>
        <div
          *ngIf="paymentInfo.is_bank_match"
          class="info-block success">
          <h3 class="info-block__headline">
            {{ "PAYMENT_PAGE.MODAL_INFO.STATUS" | translate }}
          </h3>
          <p class="info-block__description">
            {{ "PAYMENT_PAGE.MODAL_INFO.STATUS_SUCCESS" | translate }}
          </p>
        </div>
      </div>

      <div
        *ngIf="paymentStatus"
        class="payment-detail__line-right">
        <div
          *ngIf="!paymentStatus.is_bank_match"
          class="info-block danger">
          <h3 class="info-block__headline">
            {{ "PAYMENT_PAGE.MODAL_INFO.STATUS" | translate }}
          </h3>
          <p class="info-block__description">
            {{ "PAYMENT_PAGE.MODAL_INFO.STATUS_ERROR" | translate }}
          </p>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.BANK_PAYMENT_ID" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentStatus.bank_payment_id }}
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.PAYMENT_SUM" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentStatus.payment_sum }}
              <span class="currency">{{ paymentStatus.currency }}</span>
            </div>
          </div>
          <div class="info-block__line">
            <div class="info-block__line-left">
              {{ "PAYMENT_PAGE.MODAL_INFO.STATUS" | translate }}
            </div>
            <div class="info-block__line-right">
              {{ paymentStatus.payment_status }}
            </div>
          </div>
        </div>
        <div
          *ngIf="paymentStatus.is_bank_match"
          class="info-block success">
          <h3 class="info-block__headline">
            {{ "PAYMENT_PAGE.MODAL_INFO.STATUS" | translate }}
          </h3>
          <p class="info-block__description">
            {{ "PAYMENT_PAGE.MODAL_INFO.STATUS_SUCCESS" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="btn-block">
    <button
      *ngIf="
        (paymentInfo?.payment_status === 'PAID' && paymentInfo?.payment_type !== 'CASH_REFUNDS') ||
        (paymentInfo?.payment_status === 'REGISTERED' && paymentInfo?.payment_type !== 'CASH_REFUNDS') ||
        (paymentInfo?.payment_status === 'UNREGISTERED' && paymentInfo?.bank_name && paymentInfo?.payment_type !== 'CASH_REFUNDS')
      "
      [disabled]="isLoadingStatus"
      (click)="getStatus()"
      class="btn btn-accent">
      {{ "PAYMENT_PAGE.MODAL_INFO.GET_STATUS" | translate }}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{ "PAYMENT_PAGE.MODAL_INFO.CANCEL" | translate }}
    </button>
    <button
      *ngIf="paymentStatus && !paymentStatus.is_bank_match"
      routerLink="/support"
      class="btn btn-light">
      {{ "PAYMENT_PAGE.MODAL_INFO.CONNECT_ADMIN" | translate }}
    </button>
  </div>
</div>
